exports = module.exports = require("../../../../../mover/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".progress__3L83l {\n  display: grid;\n  justify-items: center;\n  align-items: center;\n}\n.progress__3L83l > svg,\n.progress__3L83l > .count__2-FLm {\n  grid-column: 1;\n  grid-row: 1;\n}\n.progress__3L83l svg {\n  width: inherit;\n  height: inherit;\n}\n.progress__3L83l svg path {\n  stroke: var(--uds-color-green-400);\n}\n.progress__3L83l .count__2-FLm {\n  font-size: inherit;\n  margin-top: -1px;\n  color: var(--uds-color-green-400);\n}\n", ""]);

// Exports
exports.locals = {
	"progress": "progress__3L83l",
	"count": "count__2-FLm"
};